// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__qlJo7","root":"Pagination_root__kehF9"};